/* Local theme integration. Real variant lines remain visible for accurate fulfillment. */
(function () {
  'use strict';
  const core = window.BayoAssortedCore;
  const config = JSON.parse(document.getElementById('bayo-assorted-config')?.textContent || '{"handles":[]}');
  const queue = core.createQueue();
  const root = window.Shopify?.routes?.root || '/';
  const reviewKey = 'bayo-assorted-cart-review';
  let needsReview = false;
  try { needsReview = sessionStorage.getItem(reviewKey) === '1'; } catch (_) {}
  const run = (task) => {
    document.documentElement.classList.add('bayo-cart-pending');
    const result = queue.run(() => navigator.locks?.request ? navigator.locks.request('bayo-cart-mutation', task) : task());
    result.finally(() => queue.idle().then(() => {
      if (!queue.pending) document.documentElement.classList.remove('bayo-cart-pending');
    })).catch(() => {});
    return result;
  };
  function recordCart(cart) {
    document.documentElement.classList.toggle('bayo-assorted-in-cart', cart.items.some((line) => config.handles.includes(line.handle)));
    return cart;
  }
  function requireReview() {
    needsReview = true;
    try { sessionStorage.setItem(reviewKey, '1'); } catch (_) {}
    showReview();
  }
  function checkReview() {
    if (needsReview) throw new core.AllocationError('REVIEW_CART', 'Please review your cart and confirm it before continuing.');
  }
  async function request(url, body, accept = 'application/json') {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(url, {
        method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
        signal: controller.signal, headers: { Accept: accept, ...(body ? { 'Content-Type': 'application/json' } : {}) },
        ...(body ? { body: JSON.stringify(body) } : {}),
      });
      const data = await response.json();
      if (!response.ok || data.status >= 400 || data.errors) throw new Error('The cart update was not accepted.');
      return data;
    } finally { clearTimeout(timeout); }
  }
  const productUrl = (handle) => `${root}products/${encodeURIComponent(handle)}`;
  async function getFamily(path) {
    const url = new URL(path, location.origin);
    if (url.origin !== location.origin) throw new Error('Invalid product URL');
    url.search = '';
    url.searchParams.set('view', 'bayo-assorted-stock');
    url.searchParams.set('_bayo', Date.now().toString());
    // Render the alternate Liquid template instead of negotiating product JSON.
    try { return await request(url.href, undefined, 'text/html'); }
    catch (_) { throw new core.AllocationError('STOCK_UNAVAILABLE', 'We could not check current stock. Please try again in a moment.'); }
  }
  const client = core.createClient({
    handles: config.handles, productUrl, getFamily, requireReview,
    getCart: async () => recordCart(await request(`${root}cart.js?_bayo=${Date.now()}`)),
    add: (items) => request(`${root}cart/add.js`, { items }),
    change: (id, quantity) => request(`${root}cart/change.js`, { id, quantity }),
  });
  function errorMessage(error) {
    return error instanceof core.AllocationError ? error.message : 'We could not check your cart. Please try again in a moment.';
  }
  function cartMessage(message) {
    const targets = document.querySelectorAll('#cart-errors, #CartDrawer-CartErrors');
    targets.forEach((target) => { target.setAttribute('role', 'alert'); target.textContent = message; });
  }
  async function sections(ids) {
    return request(`${root}cart?sections=${encodeURIComponent(ids.join(','))}&_bayo=${Date.now()}`, undefined, 'text/html');
  }
  async function refreshCart(controller, cart) {
    const descriptors = controller.getSectionsToRender();
    const rendered = await sections(descriptors.map((section) => section.section || section.id));
    for (const section of descriptors) {
      const html = rendered[section.section || section.id];
      if (!html) throw new Error('Cart section unavailable');
      const source = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector || '.shopify-section');
      const container = document.getElementById(section.id);
      const target = (section.selector && container?.querySelector(section.selector)) || container || (section.selector && document.querySelector(section.selector));
      if (!source || !target) throw new Error('Cart section target unavailable');
      target.innerHTML = source.innerHTML;
    }
    document.querySelectorAll('cart-items, cart-drawer, #main-cart-footer').forEach((node) => node.classList.toggle('is-empty', cart.item_count === 0));
    activateControls(); showReview();
  }
  function createEvent(element, items) {
    const Event = window.StandardEvents?.CartLinesUpdateEvent;
    if (!Event) return null;
    const deferred = Event.createPromise();
    element.dispatchEvent(new Event({ action: 'add', context: 'product', lines: items.map((item) => ({ merchandiseId: item.id, quantity: item.quantity })), promise: deferred.promise }));
    return deferred;
  }
  function resolveEvent(deferred, cart) {
    const Event = window.StandardEvents?.CartLinesUpdateEvent;
    if (deferred && Event) deferred.resolve({ cart: Event.createCartFromAjaxResponse(cart) });
  }
  async function addProduct(formElement, event) {
    event.preventDefault();
    const button = formElement.submitButton;
    if (button.getAttribute('aria-disabled') === 'true') return;
    button.setAttribute('aria-disabled', 'true'); button.classList.add('loading');
    formElement.querySelector('.loading__spinner')?.classList.remove('hidden');
    formElement.handleErrorMessage();
    let deferred;
    let confirmedCart;
    try {
      const input = new FormData(formElement.form);
      if (input.get('selling_plan') || [...input.keys()].some((key) => key.startsWith('properties['))) throw new core.AllocationError('UNSUPPORTED', 'This assortment cannot be customized. Please reload the product page.');
      const suppliedQuantity = input.get('quantity');
      const quantity = suppliedQuantity === null || suppliedQuantity === undefined ? 1 : Number(suppliedQuantity);
      await run(async () => {
        checkReview();
        const result = await client.add(formElement.dataset.bayoProductUrl, quantity, (items) => { deferred = createEvent(formElement, items); });
        confirmedCart = result.cart;
        resolveEvent(deferred, result.cart);
        try {
          const drawer = document.querySelector('cart-drawer');
          if (drawer) {
            const rendered = await sections(drawer.getSectionsToRender().map((section) => section.id));
            if (!rendered['cart-drawer'] || !rendered['cart-icon-bubble']) throw new Error('Cart display unavailable');
            formElement.closest('quick-add-modal')?.hide(true);
            drawer.setActiveElement(button);
            drawer.renderContents({ ...result.cart, sections: rendered });
            drawer.classList.toggle('is-empty', result.cart.item_count === 0);
            activateControls();
          } else { location.assign(`${root}cart`); }
          if (typeof publish === 'function') await publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bayo-assorted', cartData: result.cart });
        } catch (error) { requireReview(); throw error; }
      });
    } catch (error) {
      // The cart write succeeded. A rendering failure must not invite a duplicate add.
      if (confirmedCart) { location.assign(`${root}cart`); return; }
      deferred?.reject(error);
      formElement.handleErrorMessage(errorMessage(error));
      if (error.cart) {
        const drawer = document.querySelector('cart-drawer');
        if (drawer) await refreshCart(drawer, error.cart).catch(() => {});
      }
      showReview();
    } finally {
      button.removeAttribute('aria-disabled'); button.classList.remove('loading');
      formElement.querySelector('.loading__spinner')?.classList.add('hidden');
    }
  }
  async function changeLine(controller, line, quantity, event) {
    const input = controller.querySelector(`#Quantity-${line}`) || controller.querySelector(`#Drawer-quantity-${line}`);
    const key = input.dataset.quantityLineKey;
    controller.enableLoading(line);
    let confirmedCart;
    let deferred;
    try {
      await run(async () => {
        if (quantity > 0) checkReview();
        deferred = controller.createCartLinesUpdateEvent?.(quantity === 0 ? 'remove' : 'update', input.dataset.quantityVariantId, quantity, key);
        const cart = await client.change(input.dataset.bayoProductUrl, key, quantity);
        confirmedCart = cart;
        controller.resolveCartLinesUpdate?.(deferred, cart);
        try {
          await refreshCart(controller, cart);
          if (typeof publish === 'function') await publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: cart });
        } catch (error) { requireReview(); throw error; }
      });
    } catch (error) {
      // A saved quantity must never be presented as an unchanged cart after a render failure.
      if (confirmedCart) { location.assign(`${root}cart`); return; }
      deferred?.reject(error);
      input.value = input.getAttribute('value');
      if (error.cart) await refreshCart(controller, error.cart).catch(() => {});
      cartMessage(errorMessage(error)); showReview();
    } finally { controller.disableLoading(line); }
  }
  function showReview() {
    document.querySelectorAll('[data-bayo-cart-review]').forEach((node) => { node.hidden = !needsReview; });
  }
  function activateControls() {
    document.querySelectorAll('[data-bayo-checkout], [data-bayo-assorted-input]').forEach((node) => {
      if (!node.hasAttribute('data-bayo-empty')) node.disabled = false;
    });
  }
  async function checkout(event) {
    event.preventDefault(); event.stopImmediatePropagation();
    const button = event.submitter || event.target.closest('[name="checkout"]');
    if (button?.getAttribute('aria-disabled') === 'true') return;
    button?.setAttribute('aria-disabled', 'true');
    try {
      await run(async () => { checkReview(); await client.checkout(); });
      location.assign(`${root}checkout`);
    } catch (error) { cartMessage(errorMessage(error)); showReview(); button?.removeAttribute('aria-disabled'); }
  }
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-bayo-review-confirm]')) {
      needsReview = false;
      try { sessionStorage.removeItem(reviewKey); } catch (_) {}
      showReview(); cartMessage('Cart reviewed. Current stock will be checked again before checkout.');
    }
    // Always intercept native cart checkout, including stale pre-add drawer markup.
    if (event.target.closest('[name="checkout"]')) checkout(event);
  }, true);
  document.addEventListener('submit', (event) => {
    if (event.submitter?.matches('[name="checkout"]') || event.target.matches('#cart, #CartDrawer-Form')) checkout(event);
  }, true);
  document.addEventListener('DOMContentLoaded', () => { activateControls(); showReview(); });
  new MutationObserver(() => { activateControls(); showReview(); }).observe(document.documentElement, { childList: true, subtree: true });
  window.BayoAssorted = {
    addProduct, changeLine,
    // Native product/cart mutations share the same queue as assorted operations.
    cartFetch: (url, options) => run(() => fetch(url, options)),
    initProduct: (element) => {
      if (element.dataset.bayoAvailable === 'true') element.submitButton.disabled = false;
    },
  };
})();
